import {
  Constants,
  Language,
  ReduxAction,
  SourceName,
} from '../../enums/const-enums';
import { getCookieValue, getSanitizedSummary } from '../../utils/utils';

export interface ConfigState {
  absPath?: string;
  assetsPath?: string;
  language: Language;
  sourceName?: SourceName;
  summary?: string;
  summaryCss?: string;
  isSignInitialized?: boolean;
  isLoading?: boolean;
  displayType?: string;
}

const initialState: ConfigState = {
  absPath: null,
  assetsPath: '/s-t-a-t-i-c/msp/authentication/v2/vrs_4820747/assets/', // Dont remove this, null causes issues in prod
  language: Language.NL,
  sourceName: SourceName.OTHER,
  summary: null,
  summaryCss: null,
  isSignInitialized: false,
  isLoading: true,
  displayType: null,
};

export interface ConfigAction {
  type: ReduxAction;
  payload: ConfigState;
}

export const configReducer = (
  state: ConfigState = initialState,
  action: ConfigAction,
): ConfigState => {
  switch (action.type) {
    case ReduxAction.CONFIG_INIT:
      state.absPath = action.payload.absPath;
      state.assetsPath = action.payload.assetsPath;
      state.language = action.payload.language;
      state.sourceName = action.payload.sourceName;
      break;
    case ReduxAction.SIGN_INIT:
      state.language = action.payload.language;
      state.summary = getSanitizedSummary(
        state.sourceName,
        action.payload.summary,
        action.payload.summaryCss,
      );
      state.displayType = action.payload.displayType;
      state.isSignInitialized = true;
      break;
    case ReduxAction.NO_SIGN_INIT:
      state.isLoading = false;
      state.language = getCookieValue(Constants.LANGUAGE_COOKIE_NAME)
        ? state.language
        : Language.EN;
      break;
    case ReduxAction.SWITCH_LANGUAGE:
      state.language = action.payload.language;
      break;
    case ReduxAction.UI_READY:
      state.isLoading = false;
      break;
  }
  return state;
};
